import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import userPlaceholder from "../../assets/images/placeholder.jpg";
import axios from "axios";
import cookie from "js-cookie";
import { toast } from "react-toastify";
import Loader from "../../components/shared/Loader";
import { updateMeta } from "../../store/actions/metaAction";

const EmployeesShow = ({ match }) => {
	const {
		params: { employeesID },
	} = match;

	const auth = useSelector(state => state.auth.user);
	const [mainTitle, setMainTitle] = useState("");
	const [mainDescription, setMainDescription] = useState("");
	const [title, setTitle] = useState("");
	const [name, setName] = useState("");
	const [picture, setPicture] = useState(userPlaceholder);
	const [pictureName, setPictureName] = useState(userPlaceholder);
	const [loading, setLoading] = useState(true);
	const dispatch = useDispatch();

	useEffect(() => {
		onStart();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const onStart = () => {
		dispatch(
			updateMeta({
				title: "تعديل تفاصيل الموظف",
				breadcrumb: "الموظفين",
				button: {
					show: false,
					text: null,
					link: null,
				},
			})
		);
		axios
			.get(`${process.env.REACT_APP_API_URL}/posts/${employeesID}`, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			})
			.then(function (response) {
				setMainTitle(response.data.data.data.title);
				setMainDescription(response.data.data.data.description);
				setName(response.data.data.data.employees[0].name);
				setTitle(response.data.data.data.employees[0].title);
				setPicture(response.data.data.data.employees[0].image);
				setPicture(
					`${process.env.REACT_APP_MAIN_URL}${response.data.data.data.employees[0].image}`
				);
				setPictureName(response.data.data.data.employees[0].image);
				setLoading(false);
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة لاحقا!");
			});
	};

	const handlePicture = () => {
		const fileInput = document.querySelector("#picture");
		setPicture(URL.createObjectURL(fileInput.files[0]));
	};

	const handleSubmit = e => {
		e.preventDefault();
		setLoading(true);
		const image = document.querySelector("#picture");
		if (image.files[0]) {
			const data = new FormData();
			data.append("file", image.files[0]);
			axios
				.post(`${process.env.REACT_APP_API_URL}/upload`, data, {
					headers: {
						Authorization: `Bearer ${cookie.get("token")}`,
						Accept: "application/json",
						"Content-Type": "multipart/form-data",
					},
				})
				.then(response => {
					const data = {
						title: mainTitle,
						description: mainDescription,
						employees: [{ name, title, image: response.data.data.name }],
					};
					axios
						.put(
							`${process.env.REACT_APP_API_URL}/posts/${employeesID}`,
							{
								admin_id: auth.data.id,
								category_id: 6,
								data: data,
							},
							{
								headers: {
									Authorization: `Bearer ${cookie.get("token")}`,
									Accept: "application/json",
								},
							}
						)
						.then(function (response) {
							toast.success("تم تحديث الموظف بنجاح!");
							setLoading(false);
						})
						.catch(function (error) {
							toast.error("خطأ، برجاء المحاولة مره اخرى!");
							setLoading(false);
						});
				})
				.catch(error => {
					toast.error("خطأ في رفع الصورة، برجاء المحاولة مرة أخرى!");
					setLoading(false);
				});
		} else {
			const data = {
				title: mainTitle,
				description: mainDescription,
				employees: [{ name, title, image: pictureName }],
			};
			axios
				.put(
					`${process.env.REACT_APP_API_URL}/posts/${employeesID}`,
					{
						admin_id: auth.data.id,
						category_id: 6,
						data: data,
					},
					{
						headers: {
							Authorization: `Bearer ${cookie.get("token")}`,
							Accept: "application/json",
						},
					}
				)
				.then(function (response) {
					toast.success("تم تحديث الموظف بنجاح!");
					setLoading(false);
				})
				.catch(function (error) {
					console.log(error);
					toast.error("خطأ، برجاء المحاولة مره اخرى!");
					setLoading(false);
				});
		}
	};

	return (
		<section>
			{loading && <Loader />}
			<form onSubmit={handleSubmit}>
				<div className="row">
					<div className="col-md-9">
						<div className="card">
							<div className="card-body">
								<div className="form-item">
									<label htmlFor="name">العنوان</label>
									<input
										type="text"
										id="name"
										required
										value={mainTitle}
										onChange={e => setMainTitle(e.target.value)}
									/>
								</div>
								<div className="form-item">
									<label htmlFor="name">الوصف</label>
									<input
										type="text"
										id="name"
										required
										value={mainDescription}
										onChange={e => setMainDescription(e.target.value)}
									/>
								</div>
								<div className="form-item">
									<label htmlFor="name">الاسم</label>
									<input
										type="text"
										id="name"
										value={name}
										required
										onChange={e => setName(e.target.value)}
									/>
								</div>
								<div className="form-item">
									<label htmlFor="title">الوظيفة</label>
									<input
										type="text"
										id="title"
										value={title}
										required
										onChange={e => setTitle(e.target.value)}
									/>
								</div>
							</div>
						</div>
					</div>
					<div className="col-md-3">
						<div className="card">
							<div className="card-body">
								<div className="form-item">
									<input type="file" onChange={handlePicture} id="picture" />
									<img src={picture} alt="avatar" className="imagePreview" />
								</div>
							</div>
						</div>
						<div className="form-item mt-3">
							<button className="bt bt-success btn-block">ارسال</button>
						</div>
					</div>
				</div>
			</form>
		</section>
	);
};

export default EmployeesShow;
